import 'swiper/css/pagination';

export const featuredCollection = () => {
  let featuredCollection = new window.theme.swiper('.js-featuredCollection', {
    slidesPerView: 4,
    lazy: true,
    spaceBetween: 16,
    pagination: {
      el: '.featuredCollection__pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".featuredCollection-next",
      prevEl: ".featuredCollection-prev",
    },
    loop: false,
    slideToClickedSlide: false,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16,
      }
    }
  });
  return featuredCollection;
};
